import { V3ModalComponent, V3PopupComponent } from "#components";

export default defineNuxtRouteMiddleware(async (to: any) => {
  const { name, query } = to;
  const { isGPSEnabled } = useLocation();
  const { isMobile } = useDevice();

  if (isGPSEnabled) return;

  const locationRequired = ['categories-search', 'checkout'];
  if (!locationRequired.includes(name?.toString().toLowerCase() || '')) return;

  const modalComponent = isMobile ? V3PopupComponent : V3ModalComponent;
  const modal = isMobile ? useSlideover() : useModal();
  
  setTimeout(() => {
    modal.open(modalComponent, {
      component: 'location',
      closable: !locationRequired.includes(name?.toString() || ''),
      onSuccess: () => window.location.reload(),
      onClose: modal.close,
    });
  }, 1000);
});
